function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import remoteFileObjToLocal from '@uppy/utils/lib/remoteFileObjToLocal';

// Conditional type for selecting the plugin

// Conditional type for selecting the provider from the selected plugin
var View = /*#__PURE__*/function () {
  function View(plugin, opts) {
    var _this = this;
    _classCallCheck(this, View);
    this.filterItems = function (items) {
      var state = _this.plugin.getPluginState();
      if (!state.filterInput || state.filterInput === '') {
        return items;
      }
      return items.filter(function (folder) {
        return folder.name.toLowerCase().indexOf(state.filterInput.toLowerCase()) !== -1;
      });
    };
    this.recordShiftKeyPress = function (e) {
      _this.isShiftKeyPressed = e.shiftKey;
    };
    this.isChecked = function (file) {
      var _this$plugin$getPlugi = _this.plugin.getPluginState(),
        currentSelection = _this$plugin$getPlugi.currentSelection;
      // comparing id instead of the file object, because the reference to the object
      // changes when we switch folders, and the file list is updated
      return currentSelection.some(function (item) {
        return item.id === file.id;
      });
    };
    this.plugin = plugin;
    this.provider = opts.provider;
    this.opts = opts;
    this.isHandlingScroll = false;
    this.preFirstRender = this.preFirstRender.bind(this);
    this.handleError = this.handleError.bind(this);
    this.clearSelection = this.clearSelection.bind(this);
    this.cancelPicking = this.cancelPicking.bind(this);
  }
  _createClass(View, [{
    key: "preFirstRender",
    value: function preFirstRender() {
      this.plugin.setPluginState({
        didFirstRender: true
      });
      this.plugin.onFirstRender();
    }
  }, {
    key: "shouldHandleScroll",
    value: function shouldHandleScroll(event) {
      var _event$target = event.target,
        scrollHeight = _event$target.scrollHeight,
        scrollTop = _event$target.scrollTop,
        offsetHeight = _event$target.offsetHeight;
      var scrollPosition = scrollHeight - (scrollTop + offsetHeight);
      return scrollPosition < 50 && !this.isHandlingScroll;
    }
  }, {
    key: "clearSelection",
    value: function clearSelection() {
      this.plugin.setPluginState({
        currentSelection: [],
        filterInput: ''
      });
    }
  }, {
    key: "cancelPicking",
    value: function cancelPicking() {
      this.clearSelection();
      var dashboard = this.plugin.uppy.getPlugin('Dashboard');
      if (dashboard) {
        // @ts-expect-error impossible to type this correctly without adding dashboard
        // as a dependency to this package.
        dashboard.hideAllPanels();
      }
    }
  }, {
    key: "handleError",
    value: function handleError(error) {
      var _error$cause;
      var uppy = this.plugin.uppy;
      var message = uppy.i18n('companionError');
      uppy.log(error.toString());
      if (error.isAuthError || ((_error$cause = error.cause) == null ? void 0 : _error$cause.name) === 'AbortError') {
        // authError just means we're not authenticated, don't show to user
        // AbortError means the user has clicked "cancel" on an operation
        return;
      }
      uppy.info({
        message: message,
        details: error.toString()
      }, 'error', 5000);
    }
  }, {
    key: "registerRequestClient",
    value: function registerRequestClient() {
      this.requestClientId = this.provider.provider;
      this.plugin.uppy.registerRequestClient(this.requestClientId, this.provider);
    }

    // TODO: document what is a "tagFile" or get rid of this concept
  }, {
    key: "getTagFile",
    value: function getTagFile(file) {
      var tagFile = {
        id: file.id,
        source: this.plugin.id,
        name: file.name || file.id,
        type: file.mimeType,
        isRemote: true,
        data: file,
        // @ts-expect-error meta is filled conditionally below
        meta: {},
        body: {
          fileId: file.id
        },
        remote: {
          companionUrl: this.plugin.opts.companionUrl,
          // @ts-expect-error untyped for now
          url: "".concat(this.provider.fileUrl(file.requestPath)),
          body: {
            fileId: file.id
          },
          providerName: this.provider.name,
          provider: this.provider.provider,
          requestClientId: this.requestClientId
        }
      };
      if (file.thumbnail) {
        tagFile.preview = file.thumbnail;
      }
      if (file.author) {
        if (file.author.name != null) tagFile.meta.authorName = String(file.author.name);
        if (file.author.url) tagFile.meta.authorUrl = file.author.url;
      }

      // add relativePath similar to non-remote files: https://github.com/transloadit/uppy/pull/4486#issuecomment-1579203717
      if (file.relDirPath != null) tagFile.meta.relativePath = file.relDirPath ? "".concat(file.relDirPath, "/").concat(tagFile.name) : null;
      // and absolutePath (with leading slash) https://github.com/transloadit/uppy/pull/4537#issuecomment-1614236655
      if (file.absDirPath != null) tagFile.meta.absolutePath = file.absDirPath ? "/".concat(file.absDirPath, "/").concat(tagFile.name) : "/".concat(tagFile.name);
      return tagFile;
    }
    /**
     * Toggles file/folder checkbox to on/off state while updating files list.
     *
     * Note that some extra complexity comes from supporting shift+click to
     * toggle multiple checkboxes at once, which is done by getting all files
     * in between last checked file and current one.
     */
  }, {
    key: "toggleCheckbox",
    value: function toggleCheckbox(e, file) {
      e.stopPropagation();
      e.preventDefault();
      e.currentTarget.focus();
      var _this$plugin$getPlugi2 = this.plugin.getPluginState(),
        folders = _this$plugin$getPlugi2.folders,
        files = _this$plugin$getPlugi2.files;
      var items = this.filterItems(folders.concat(files));
      // Shift-clicking selects a single consecutive list of items
      // starting at the previous click.
      if (this.lastCheckbox && this.isShiftKeyPressed) {
        var _this$plugin$getPlugi3 = this.plugin.getPluginState(),
          _currentSelection = _this$plugin$getPlugi3.currentSelection;
        var prevIndex = items.indexOf(this.lastCheckbox);
        var currentIndex = items.indexOf(file);
        var newSelection = prevIndex < currentIndex ? items.slice(prevIndex, currentIndex + 1) : items.slice(currentIndex, prevIndex + 1);
        var reducedNewSelection = [];

        // Check restrictions on each file in currentSelection,
        // reduce it to only contain files that pass restrictions
        var _iterator = _createForOfIteratorHelper(newSelection),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;
            var uppy = this.plugin.uppy;
            var restrictionError = uppy.validateRestrictions(remoteFileObjToLocal(item), [].concat(_toConsumableArray(uppy.getFiles()), reducedNewSelection));
            if (!restrictionError) {
              reducedNewSelection.push(item);
            } else {
              uppy.info({
                message: restrictionError.message
              }, 'error', uppy.opts.infoTimeout);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        this.plugin.setPluginState({
          currentSelection: _toConsumableArray(new Set([].concat(_toConsumableArray(_currentSelection), reducedNewSelection)))
        });
        return;
      }
      this.lastCheckbox = file;
      var _this$plugin$getPlugi4 = this.plugin.getPluginState(),
        currentSelection = _this$plugin$getPlugi4.currentSelection;
      if (this.isChecked(file)) {
        this.plugin.setPluginState({
          currentSelection: currentSelection.filter(function (item) {
            return item.id !== file.id;
          })
        });
      } else {
        this.plugin.setPluginState({
          currentSelection: currentSelection.concat([file])
        });
      }
    }
  }, {
    key: "setLoading",
    value: function setLoading(loading) {
      this.plugin.setPluginState({
        loading: loading
      });
    }
  }]);
  return View;
}();
export { View as default };